export const appWidth = 1500;
export const aboutmeWidth = 1000;
export const mediaBreak = "650px";
export const projectMediaBreak = "750px";
export const borderRad = 5;
export const transition = 0.3;

export const startInDarkMode = false;

export const appColour = '#E8E8E8';
export const appColourDark = '#252525';
export const fontColour = "#3e3e3e";
export const fontColourDarkMode = "#e5e1d8"; // floralwhite shade

// https://favicon.io/favicon-generator/
// favicon font - Merriweather

// https://www.cssmatic.com/noise-texture

export const buttonOrange = "#FFA500";
export const buttonBlue = "#005aFF";
export const midGrey = "#808080";

export const landingHeaderFont = fontColourDarkMode;

export const landingHeader = "#000000";
export const landingFooter = landingHeader;
export const headerHeight = 50;
export const footerHeight = 30;
export const landingHeadFootOpacity = 1;

export const projectsMaxWidth = "";  // app is narrow enough
export const projectCardBack = "#f8f8f8";
// export const projectCardBorder = midGrey;
export const projectCardBackDark = "#151515";

export const landingCaption = projectCardBack;
export const landingCaptionDark = "#151515";
export const landingCaptionBorder = midGrey;
export const landingCaptionMaxWidth = "900px";

export const landingBoysBack = midGrey;
export const landingBoysButton = appColour;
export const landingBoysFont = fontColour;
export const landingBoysMaxWidth = "1000px";

// export const aboutmeBack = "#F5F5F5";
// export const aboutmeBackDark = "#282828";
export const aboutmeButton = "#d3d3d3";
export const aboutmeButtonDark = "#505050";
export const aboutmeSelectedButton = "#c0c0c0";
export const aboutmeSelectedButtonDark = "#606060";
export const aboutmeButtonHov = "#909090";
export const aboutmeInnerPad = "10px";
export const aboutmeColor = '#FE840E';
// export const aboutmeMaxWidth = "";
